exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-white{background-color:#fff}.clear:after{content:\"\";display:table;clear:both}.checkbox label{font-family:Milo Medium,Verdana;font-size:1em;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-719aeb74","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?data=@import "./src/scss/variables";@import "./src/scss/mixins";@import "./src/scss/helper";!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/check-box/CheckBox.vue
// module id = 202
// module chunks = 0